/* unplugin-vue-components disabled */import { render } from "./MessageLoading.vue?vue&type=template&id=3ba9f73a&scoped=true"
const script = {}

import "./MessageLoading.vue?vue&type=style&index=0&id=3ba9f73a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@5.8.3__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba9f73a"]])

export default __exports__